import { z } from "zod";

export const templateCategoryCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
});

export const templateCategoryUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
  description: z.string().optional(),
});

export type TemplateCategoryFormData = z.infer<typeof templateCategoryCreateSchema>;
export type TemplateCategoryUpdateFormData = z.infer<typeof templateCategoryUpdateSchema>;

export interface TemplateCategoryRequest {
  name: string;
  description?: string;
}

export interface TemplateCategory {
  id: string;
  name: string;
  description?: string;
  tenantId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface TemplateCategoryResult {
  templateCategories: TemplateCategory[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface TemplateCategoryFilters {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface UpdateTemplateCategoryPayload {
  id: string;
  templateCategory: TemplateCategoryUpdateFormData;
}

